<template>
  <div class="myAppioment">
    <img src="../assets/image/register.png"/>
    <div class="center">
      <van-form @submit="submit">
        <van-field
            v-model="form.nickName"
            name="姓名"
            label="姓名"
            placeholder="请填写姓名"
            :rules="[{ required: true }]"
        />
        <van-field
            v-model="form.phone"
            name="手机号"
            label="手机号"
            placeholder="请输入手机号"
            :rules="[{ required: true }]"
        />
        <div style="margin: 16px;">
          <van-button class="search" round block type="info" native-type="submit">查看预约</van-button>
        </div>
      </van-form>
    </div>
    <div class="notice">
      本次查询仅针对有证件号码，手机号登记的个人客户，医院及单位团体送检的请按原定方式咨询！
    </div>
  </div>
</template>

<script>

import {getDetail, SubmitOrder} from '@/api/order/index.js';
import {Toast} from 'vant';

export default {
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F4F4F4');
  },
  name: "myAppioment.vue",
  data() {
    return {
      num: '获取验证码',
      form: {
        nickName: '',
        phone: '',
        code: ''
      },
      openId: this.$route.query.openId
    };
  },
  created() {
    // console.log(this.openId);
    // this.myBook();
  },
  methods: {
    submit() {
      //手机号和名字不能为空
      if (this.form.nickName && this.form.phone) {
        //不为空就查看结果
        this.$router.push({path: 'order', query: {nickName: this.form.nickName, phone: this.form.phone}});
      } else {
        //为空提示用户 请填写
        // Toast.fail('请输入预约的姓名和手机号');
        this.$toast('请输入预约的姓名和手机号');
      }
    },
  }
};
</script>

<style scoped lang='less'>
.register {
  width: 750px;
}

img {
  width: 100%;
}

.center {
  width: 750px;
  height: 480px;
  background-color: #fff;
  padding: 50px 50px;
  box-sizing: border-box;
  margin-top: 20px;

  .van-cell {
    height: 100px;
    align-items: center;
    font-size: 32px;
    justify-content: space-around;
    font-weight: 600;

    .van-cell__value {
      font-size: 28px;
      color: #919191;
      height: 28px;
      flex: 2;
    }
  }

  .search {
    height: 80px;
    background-color: #48BB9C;
    border: none;
    font-size: 32px;
    margin-top: 70px;
  }
}

.notice {
  width: 639px;
  font-size: 28px;
  margin: 30px auto;
  color: #BA0000;
  line-height: 40px;
}

</style>
